"use client"

import { useEntityViewIncrement } from "@/app/hooks/useEntityViewIncrement"
import type { EntityType } from "@/app/types"

export function EntityViewIncrementer({
  entityId,
  entityType,
}: {
  entityId?: string | null
  entityType?: EntityType
}) {
  useEntityViewIncrement(entityId, entityType)
  return null
}
